function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export default class AssetProxy {
  constructor({
    url,
    file,
    path,
    field
  }) {
    _defineProperty(this, "url", void 0);
    _defineProperty(this, "fileObj", void 0);
    _defineProperty(this, "path", void 0);
    _defineProperty(this, "field", void 0);
    this.url = url ? url : file ? window.URL.createObjectURL(file) : '';
    this.fileObj = file;
    this.path = path;
    this.field = field;
  }
  toString() {
    return this.url;
  }
  async toBase64() {
    const blob = await fetch(this.url).then(response => response.blob());
    if (blob.size <= 0) {
      return '';
    }
    const result = await new Promise(resolve => {
      const fr = new FileReader();
      fr.onload = readerEvt => {
        var _readerEvt$target;
        const binaryString = ((_readerEvt$target = readerEvt.target) === null || _readerEvt$target === void 0 ? void 0 : _readerEvt$target.result) || '';
        resolve(binaryString.toString().split('base64,')[1]);
      };
      fr.readAsDataURL(blob);
    });
    return result;
  }
}
export function createAssetProxy({
  url,
  file,
  path,
  field
}) {
  return new AssetProxy({
    url,
    file,
    path,
    field
  });
}